import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton, useMediaQuery, Drawer, List, ListItem, ListItemText } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';

export default function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'About Us', to: '/about' },
    { label: 'Our Products', to: '/products' },
    { label: 'Contact Us', to: '/contact' },
  ];

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar sx={{ justifyContent: 'space-between', flexWrap: 'wrap', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', py: { xs: 1, sm: 0 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', width: { xs: '100%', sm: 'auto' }, justifyContent: { xs: 'space-between', sm: 'flex-start' } }}>
          <img 
            src="/aqeus-logo.jpg" 
            alt="Aqeus Healthcare Logo" 
            style={{ 
              height: isMobile ? 36 : 56, 
              marginRight: 16,
              cursor: 'pointer'
            }} 
            onClick={handleLogoClick}
          />
          {isMobile && (
            <IconButton edge="end" color="inherit" onClick={() => setDrawerOpen(true)}>
              <MenuIcon />
            </IconButton>
          )}
        </Box>
        {!isMobile && (
          <Box sx={{ display: 'flex', gap: 2 }}>
            {navLinks.map(link => (
              <Button key={link.to} color="inherit" component={Link} to={link.to}>{link.label}</Button>
            ))}
          </Box>
        )}
        {!isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <PhoneIcon fontSize="small" />
            <Typography variant="body2">+91-9974301565</Typography>
            <EmailIcon fontSize="small" sx={{ ml: 2 }} />
            <Typography variant="body2">aqeushealthcare@gmail.com</Typography>
            <IconButton href="#" color="inherit" size="small"><FacebookIcon /></IconButton>
            <IconButton href="#" color="inherit" size="small"><InstagramIcon /></IconButton>
          </Box>
        )}
      </Toolbar>
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 250 }} role="presentation" onClick={() => setDrawerOpen(false)}>
          <List>
            {navLinks.map(link => (
              <ListItem button component={Link} to={link.to} key={link.to}>
                <ListItemText primary={link.label} />
              </ListItem>
            ))}
            <ListItem>
              <PhoneIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography variant="body2">+91-9974301565</Typography>
            </ListItem>
            <ListItem>
              <EmailIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>aqeushealthcare@gmail.com</Typography>
            </ListItem>
             <ListItem>
              <ListItemText primary="Follow Us" sx={{ mr: 1 }} />
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton href="#" color="inherit" size="small"><FacebookIcon /></IconButton>
                <IconButton href="#" color="inherit" size="small"><InstagramIcon /></IconButton>
              </Box>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}